<app-table
  [selectable]="false"
  [columns]="tableColumns"
  [dataSource]="dataSource"
  [dataSourceParams]="tableDataSourceParams"></app-table>
